@use "../../styles/breakpoint.module.scss" as *;

.root {
    composes: darkBase from "../../styles/theming.module.css";
    background-color: rgb(var(--black-base) / 65%);
    backdrop-filter: blur(15px);
    padding-inline: var(--labui-container-margin);
    position: sticky;
    top: 0;
    z-index: 90;
    display: flex;
    justify-content: space-between;

    // set in styles/pdp.module.scss
    height: var(--scroll-nav-menu-block-height, auto);
}

.right {
    padding-inline: var(--spacer-24);
    flex-shrink: 0;
}

.navMenuFullBleed {
    & ul {
        justify-content: flex-start;
        gap: var(--spacer-24);

        @media ($below-mobile) {
            gap: var(--spacer-16);
        }
    }

    & li {
        padding: 0 var(--spacer-8);
        position: relative;
    }

    // Pulled from thelab-ui to reset links in a richtext context
    & a {
        padding: var(--spacer-24) 0;
        cursor: pointer;
        display: inline-block;
        color: inherit;
        font: var(--font-button);
        line-height: inherit;
        text-decoration: none;
    }
}

@keyframes spin-gradient {
    from {
        --xcient-gradient-deg: 0deg;
    }

    to {
        --xcient-gradient-deg: 360deg;
    }
}

.menuItemSelected::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100px;
    background: conic-gradient(
        from var(--xcient-gradient-deg) at var(--xcient-gradient-position),
        var(--xcient-gradient-stops)
    );
    clip-path: inset(97px 0 0 0);
    animation: spin-gradient 10s linear infinite;
}
